import {
  Facebook,
  Twitter,
  Linkedin,
  Youtube,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
import { FaInstagram } from "react-icons/fa";
import { Container, FooterColumn } from "./index";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const footerData = [
  {
    title: "Support",
    links: [
      { name: "Privacy Policy", path: "/privacy-policy" },
      { name: "Terms and Conditions", path: "/terms-and-conditions" },
      { name: "Return Policy", path: "/return-policy" },
      { name: "Shipping Policy", path: "/shipping-policy" },
      { name: "FAQs", path: "/faqs" },
    ],
  },
  {
    title: "Services",
    links: [
      { name: "RPTO Establishment", path: "/establishment-rpto" },
      { name: "Drone Services", path: "/drone-services-page" },
      { name: "Careers", path: "/jobs-hire-page" },
      { name: "Drone as a service (DAAS)", path: "/daas-service-page" },
      { name: "Tender as a service (TAAS)", path: "/taas" },
      { name: "Tenders", path: "/all-tenders" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-[#001D4A] text-white">
      {/* Top Section */}
      <Container>
        <div className="py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-12 gap-y-10">
          {/* Dynamic Columns */}
          {footerData.map((section, index) => (
            <FooterColumn
              key={index}
              title={section.title}
              links={section.links}
            />
          ))}

          {/* Static Contact Column */}
          <div>
            <h3 className="text-[#FFDF20] font-semibold">Connect With Us</h3>
            <div className="w-full h-[1px] bg-[#1447E6] mt-2"></div>

            {/* Social Icons */}
            <div className="flex gap-4 mt-4 mb-6">
              <Link
                to="https://www.facebook.com/profile.php?id=61558675168815"
                className="hover:text-[#FFDF20] cursor-pointer transition text-white"
                target="_blank"
              >
                <Facebook size={18} />
              </Link>
              <Link
                to="https://www.instagram.com/drone.planetofficial/"
                className="hover:text-[#FFDF20] cursor-pointer transition text-white"
                target="_blank"
              >
                <FaInstagram size={18} />
              </Link>
              <Link
                to="https://www.linkedin.com/company/drone-planet/posts/?feedView=all"
                className="hover:text-[#FFDF20] cursor-pointer transition text-white"
                target="_blank"
              >
                <Linkedin size={18} />
              </Link>
              {/* <Link
                to="https://www.youtube.com/@drone.planet"
                className="hover:text-[#FFDF20] cursor-pointer transition text-white"
                target="_blank"
              >
                <Youtube size={18} />
              </Link> */}
            </div>

            {/* Contact Info */}
            <div className="space-y-4 text-sm text-[#D1D5DC]">
              {/* Phone */}
              <a
                href="tel:+919773571992"
                className="flex items-center gap-3 hover:text-white transition group"
                aria-label="Call +91 97735 71992"
              >
                <Phone
                  size={16}
                  className="shrink-0 text-[#D1D5DC] group-hover:text-[#FFDF20]"
                />
                <span className="leading-5 text-[#D1D5DC] hover:text-[#FFDF20] transition">
                  +91 97735 71992
                </span>
              </a>

              {/* Email */}

              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@droneplanet.in"
                className="flex items-center gap-3 hover:text-white transition group"
                aria-label="Email sales@droneplanet.in"
              >
                <Mail
                  size={16}
                  className="shrink-0 text-[#D1D5DC] group-hover:text-[#FFDF20]"
                />
                <span className="leading-5 text-[#D1D5DC] hover:text-[#FFDF20] transition">
                  For Sales: sales@droneplanet.in
                </span>
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=support@droneplanet.in"
                className="flex items-center gap-3 hover:text-white transition group"
                aria-label="Email support@droneplanet.in"
              >
                <Mail
                  size={16}
                  className="shrink-0 text-[#D1D5DC] group-hover:text-[#FFDF20]"
                />
                <span className="leading-5 text-[#D1D5DC] hover:text-[#FFDF20] transition">
                  For Support: support@droneplanet.in
                </span>
              </a>

              {/* Address */}
              <a
                href="https://maps.google.com/?q=Udyog+Vihar+Phase+IV+Gurugram"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 hover:text-white transition group"
                aria-label="Open location in Google Maps"
              >
                <MapPin
                  size={16}
                  className="mt-[3px] shrink-0 text-[#D1D5DC] group-hover:text-[#FFDF20]"
                />
                <span className="leading-5 text-[#D1D5DC] hover:text-[#FFDF20] transition">
                  Plot Number - 251, Ground Floor, Udyog Vihar, Phase IV, Sector
                  18, Gurugram, Haryana - 122015
                </span>
              </a>
            </div>
          </div>
        </div>
      </Container>

      {/* Bottom Section */}
      <div className="border-t border-[#1447E6]">
        <Container>
          <div className="text-center text-xs text-gray-300 py-4">
            Copyright © 2026. Drone Planet | All rights reserved
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
